export var awards = [
    { name:'Best Print In Exhibition', winner:'Nathan Comben - "Outside Washing Line"' },
    { name:'Monochrome Print Award', winner:'Terri Bethell - "The Pianist"' },
    { name:'Nature Print Award', winner:'Christopher Goldsack - "Banded Damoiselle (Male)"' },
    { name:'Photo-Travel Award', winner:'Moni Kenward - "Weaving on a Loom"' },
    { name:'Best Advanced Print Award', winner:'Ann Healey FRPS DPAGB EFIAP/s BPE4* - "Snow Bunting in Snow"' },
    { name:'Best Intermediate Print Award', winner:'Vicki Portanier - "Lion, South Africa"' },
    { name:'Best Club Class Print Award', winner:'Bea Davies - "Raindrops Keep Falling on my Head"' },
    { name:'Best PDI In Exhibition', winner:'Vicki Portanier - "Deep Thoughts on a Grey Day"' },
    { name:'Nature PDI Award', winner:'Ann Healey FRPS DPAGB EFIAP/s BPE4* - "Cuckoo in Flight"' },
    { name:'PDI Travel Award', winner:'Nathan Comben - "Ape City Tour"' },
    { name:'Best Mono PDI Award', winner:'Chris Brooks - "Watching You"' },
    { name:'Best Advanced PDI Award', winner:'Moni Kenward - "Enjoying a cup of Masala Chai"' },
    { name:'Best Intermediate PDI Award', winner:'Stuart Carter - "Up and Over"' },
    { name:'Best Club Class PDI Award', winner:'Sonia Bonkat - "Harvest Mice on a Flower"' }
];


// WEBPACK FOOTER //
// ./src/data/awards.js